import { defineMessages } from 'react-intl';

export const messages: {
	search: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	searchIconLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	search: {
		id: 'dropdown_search',
		defaultMessage: 'Search',
		description: 'Subheading text for mimic query search',
	},
	searchIconLabel: {
		id: 'dropdown_search_icon_label',
		defaultMessage: 'Search',
		description: 'Label text for search icon',
	},
});
